import { render, staticRenderFns } from "./timelineSetupForm.vue?vue&type=template&id=51955eaf&scoped=true&"
import script from "./timelineSetupForm.vue?vue&type=script&lang=js&"
export * from "./timelineSetupForm.vue?vue&type=script&lang=js&"
import style0 from "./timelineSetupForm.vue?vue&type=style&index=0&id=51955eaf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51955eaf",
  null
  
)

export default component.exports